export class QualityPlan {
    constructor({
          id= null, 
          planCode= ``,  
          testPlanCode='',
          planDateStr=``,
          locName= ``, 
          planShift= ``,
          itemName= ``,
          itemId='',
          planMat='',
          planOutput='',
          planRate='',
          planStartStr='',
          planEndStr='',
          qualityItem=[],
          locId = '',

      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.testPlanCode=testPlanCode;
      this.planDateStr = planDateStr;
      this.planShift = planShift;
      this.itemName = itemName;
      this.itemId=itemId;
      this.planMat=planMat;
      this.planOutput=planOutput;
      this.planRate=planRate;
      this.planStartStr=planStartStr;
      this.planEndStr=planEndStr;
      this.qualityItem=qualityItem;
      this.locName = locName;
      this.locId = locId;
    }
  }
  export function gridFields() {
    return Object.freeze([ 
     
        {
            key: 'planCode',
            label: 'lbl.qualityPlan.planCode',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'testPlanCode',
          label: 'lbl.qualityPlan.testPlanCode',
          sortable: true,
          form: {
            type: 'input'
          }
      },
        {
          key: 'planDate',
          label: 'lbl.qualityPlan.planDate',
          sortable: true,
          form: {
            type: 'date'
          }
        },
        {
          key: 'planStart',
          label: 'lbl.qualityPlan.planStart',
          sortable: true,
          // notInTable:true,
          form: {
            type: 'dateTime'
          }
        },
        {
          key: 'planEnd',
          label: 'lbl.qualityPlan.planEnd',
          sortable: true,
          // notInTable:true,
          form: {
            type: 'dateTime'
          }
        },
        {
          key: 'locName',
          label: 'lbl.qualityPlan.planPlant',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'planShift',
          label: 'lbl.qualityPlan.planShift',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        
        {
          key: 'planMat',
          label: 'lbl.qualityPlan.planMat',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'planOutput',
          label: 'lbl.qualityPlan.planOutput',
          sortable: true,
          notInTable:true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'planRate',
          label: 'lbl.qualityPlan.planRate',
          sortable: true,
          notInTable:true,
          form: {
            type: 'input'
          }
        },
      
        {
          key: 'itemName',
          label: 'lbl.qualityPlan.itemName',
          sortable: true,
          form: {
            type: 'input'
          }
        }  
    ]);
  }
  
  export const fields = Object.freeze(Object.keys(new QualityPlan()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.startDateFilter',
    'filter.endDateFilter',
    'filter.locNameFilter',
    'filter.planShiftFilter',
    'filter.planMatFilter',
   
  ];
  export const filter = {
    'planCodeFilter': "",
    'startDateFilter': formate(new Date()),
    'endDateFilter':formate(new Date()),
    'locNameFilter':"default",
    'planShiftFilter':"",
    'planMatFilter':"",
  };

  export function formate(date)  {

    var y=date.getFullYear();
    var m=date.getMonth()+1;
    var d=date.getDate();
    var h=date.getHours();
    m=m<10 ? '0'+m :m;
    if(h>=8){
      d=d<10 ? '0'+d :d;
    }else{
      d=d<10-1 ? '0'+d-1 :d-1
    }
    

    return y+'-'+m+'-'+d;

  }